<template>
  <div :class="$style['engagementLayoutWrap']">
    <div v-if="hasHeadingSlot">
      <h3>
        <slot name="heading" />
        <mds-button
          v-if="hasInfoTooltipSlot"
          type="button"
          variation="icon-only"
          icon="info-circle"
          @mouseover="toggle = true"
          @mouseleave="toggle = false"
          @focus="toggle = true"
          @blur="toggle = false"
          id="default-trigger"
          >info</mds-button
        >

        <mds-tooltip
          v-if="hasInfoTooltipSlot && toggle"
          triggered-by="default-trigger"
          v-model="toggle"
          :position="['right-center']"
        >
          <slot name="info-tooltip" />
        </mds-tooltip>
      </h3>
    </div>

    <div :class="$style['cf-supportingText']" v-if="hasSubheadingSlot">
      <slot name="sub-heading" />
    </div>

    <div
      :class="$style['cf-subpageBody']"
      v-if="hasLeftSideBarSlot || hasRightSideBarSlot"
    >
      <mds-layout-grid>
        <mds-row>
          <mds-col :cols="12" :cols-at-s=leftBar v-if="hasLeftSideBarSlot" :class="source=='basicscreen'? $style['cf-left']:''" @scroll.native="onScrollLeft()">
            <slot name="left-side-bar" />
         
          </mds-col>
          <mds-col :cols="12" :cols-at-s=rightBar v-if="hasRightSideBarSlot">
            <slot name="right-side-bar" />
          </mds-col>
        </mds-row>
      </mds-layout-grid>
    </div>

    <div v-if="hasFooterSlot">
      <slot name="footer" />
    </div>
    <!--end of cf-subPageBody-->
  </div>
  <!--end of cf-subPageWrap-->
</template>

<script>
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import MdsTooltip from "@mds/tooltip";
import { MdsButton } from "@mds/button";

export default {
  props: {
    leftBar: {
      type: Number,
      default: 3,
    },
    rightBar: {
      type: Number,
      default: 9,
    },
    source:{
      type: String 
    }
  },
  name: "engagement-layout",
  components: {
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsTooltip,
    MdsButton,
  },
  data() {
    return { toggle: false };
  },
  computed: {
    hasHeadingSlot() {
      return this.$slots["heading"];
    },
    hasSubheadingSlot() {
      return this.$slots["sub-heading"];
    },
    hasLeftSideBarSlot() {
      return this.$slots["left-side-bar"];
    },
    hasRightSideBarSlot() {
      return this.$slots["right-side-bar"];
    },
    hasFooterSlot() {
      return this.$slots["footer"];
    },
    hasInfoTooltipSlot() {
      return this.$slots["info-tooltip"];
    },
  },
  methods:{
    onScrollLeft()
    {
       let elements = document.getElementsByClassName('mds-popover_CashFlow')
       for(let i=0;i< elements.length;i++)
       {
        elements[i].style.display = 'none';
       }
    }
  }
};
</script>

<style lang="scss" scoped module>
.engagementLayoutWrap {
  .cf-supportingText {
    padding-top: $mds-space-1-x;
    padding-bottom: $mds-space-1-x;
  }
  .cf-subpageBody {
    background-color: transparent;
    margin-top: $mds-space-4-x;
  }

.cf-supportingText {

  padding-top: $mds-space-1-x;

  padding-bottom: $mds-space-1-x;

}

.cf-subpageBody {

  background-color: transparent;

  margin-top: $mds-space-4-x;

}



}
</style>
